import React, { useState, useEffect } from 'react';

const SummaryComponent = ({ projectData }) => {
    const [summary, setSummary] = useState({
        highCountSum: 0,
        upCount: 0,
        downCount: 0,
        olderThanOneWeekCount: 0
    });

    useEffect(() => {
        const currentDate = new Date();
        const oneWeekAgo = new Date(currentDate.setDate(currentDate.getDate() - 7));

        const calculatedSummary = projectData.reduce((acc, item) => {
            // Sum of highCount
            acc.highCountSum += item.highCount;

            // Count of appStatus UP
            if(item?.configURLs?.statusURL){
            if (item.appstatus === 'UP') {
                acc.upCount += 1;
            }else{ acc.downCount += 1;
            }
        }
        
       
            // Count of creationDate older than one week
            const creationDate = new Date(item.creationDate);
            if (creationDate < oneWeekAgo) {
                acc.olderThanOneWeekCount += 1;
            }

            return acc;
        }, {
            highCountSum: 0,
            upCount: 0,
            downCount: 0,
            olderThanOneWeekCount: 0
        });

        setSummary(calculatedSummary);
    }, [projectData]);

    return (
        <div>
            Total Applications:<strong> {projectData?.length}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Sum of High Issues:<strong> {summary.highCountSum}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Server's UP:<strong> {summary.upCount}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Server's DOWN: <strong>{summary.downCount}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Reports older than one week:<strong> {summary.olderThanOneWeekCount}</strong>
        </div>
    );
};

export default SummaryComponent;
